import { Box, BoxProps } from "@chakra-ui/react";

export interface DrawerContentProps extends BoxProps {}

export const DrawerContent = (props: DrawerContentProps) => {
  return <Box p={4} {...props} />;
};
